import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { Button } from "../components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { fetchMe } = useAuth();
  const [state, setState] = useState("checking");
  const sid = params.get("session_id");

  useEffect(() => {
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/billing/status/${sid}`);
        if (data.payment_status === "paid") { setState("paid"); fetchMe(); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setState("failed"); return; }
      } catch { setState("failed"); return; }
      if (++tries < 8) setTimeout(poll, 2000); else setState("pending");
    };
    if (sid) poll(); else setState("failed");
  }, [sid, fetchMe]);

  return (
    <div className="mx-auto max-w-md space-y-4 text-center" data-testid="billing-success">
      {state === "checking" && <><Loader2 className="mx-auto h-12 w-12 animate-spin text-primary" /><p>Confirming your subscription…</p></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto h-16 w-16 text-secondary" /><h1 className="font-head text-2xl font-extrabold">Subscription active</h1><p className="text-muted-foreground">Your agency is ready for real client workflows.</p></>}
      {state === "pending" && <><Loader2 className="mx-auto h-12 w-12 text-accent" /><p>Payment is still processing. Status will update automatically.</p></>}
      {state === "failed" && <><XCircle className="mx-auto h-16 w-16 text-destructive" /><p>We couldn't confirm the payment.</p></>}
      <Button className="rounded-full" onClick={() => navigate("/app/settings?tab=billing")}>Back to billing</Button>
    </div>
  );
}
